<template>
  <div class="LoadingPage">
    <div class="Loading">
      <svg
        id="LoadingBackground"
        src="/assets/loading-background.svg"
        alt="loading-background"
        width="972"
        height="550"
        viewBox="0 0 972 550"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Frame 3">
          <path
            id="Portal"
            d="M873.32 505.39C877.38 511.91 883.95 514.39 889.14 519.25C894.33 524.11 898.14 534.46 893.94 540.81C896.83 552.59 910.66 550.89 916.85 541.68C923.04 532.47 925.05 519.45 930.51 509.45C933.37 509.66 933.64 515.45 932.12 518.71C930.6 521.97 928.12 525.02 928.48 528.82C929.21 536.58 939.19 532.73 940.42 525.09C941.65 517.45 938.84 509.39 940.15 501.77C942.27 489.41 954.24 482.93 955.25 470.32C955.62 465.84 954.46 461.43 953.52 457.11C949.39 438 948.945 418.277 952.21 399L957.27 406.32C966.77 400.63 964.4 381.32 958.4 369.9C952.4 358.48 943.87 346.7 945.88 333.02C945.993 331.611 946.495 330.261 947.33 329.12C951.33 324.8 954.07 336.82 958.69 339.77C961.32 341.44 964.51 339.66 966.62 336.99C976.35 324.71 969.03 302.99 960.62 289.06C952.21 275.13 942.32 256.95 948.74 241.24C952.26 239.24 955.3 245.32 956 250.36C956.7 255.4 957.67 261.84 961.43 262.79C967.13 264.23 968.25 252.28 966.63 244.79L952.58 180.12C951.69 176.03 950.83 171.47 952.26 167.67C953.69 163.87 958.52 162.56 959.85 166.43C969.02 143.06 943.46 117.73 947.25 91.82L961.02 102.73C966.02 94.73 962.62 82.26 957.31 74.67C952 67.08 944.91 61.52 941.08 52.48L942.62 54.35C944.23 47.47 949.7 43.82 953.15 38.29C956.6 32.76 956.15 21.45 950.76 21.29C948.22 21.23 946.16 23.92 943.76 25.13C931.62 31.33 924.82 -0.939964 911.85 0.480036C904.31 1.30004 900.49 13.37 900.45 23.48C900.41 33.59 902.38 44.23 899.45 53.59L891.75 41.59C887.52 44.54 884.87 51.13 885.35 57.49C885.67 61.64 887.18 65.49 887.89 69.49C890.71 85.63 881.01 100.18 873.89 113.74C866.77 127.3 862.97 149.3 873.55 157.9C875.419 155.788 876.956 153.404 878.11 150.83C879.78 172.01 892.9 197.07 882.41 213.35C883.06 209.52 880.82 205.28 877.91 204.81C871.42 208.27 870.48 220.3 872.49 229.26C874.5 238.22 878.41 246.85 877.8 256.17C876.94 269.26 867.8 278.01 861.66 288.17C855.52 298.33 853.66 317.22 862.85 321.73C865.85 318.52 863.74 311.78 865.34 307.11C867.34 301.38 874.28 302.11 877.05 307.18C879.82 312.25 879.35 319.35 877.93 325.37C876.51 331.39 874.27 337.14 873.81 343.42C872.98 355 878.29 365.53 881.34 376.42C884.39 387.31 883.93 402.52 875.97 407.15C880.77 408.69 881.97 417.49 880.32 423.74C878.67 429.99 875.4 435.51 874.8 442.07C873.8 453.07 880.47 462.26 886.11 470.37C891.75 478.48 897.11 490.12 893.28 499.94L876.89 485.37C870.62 485.84 869.27 498.87 873.32 505.39ZM932.55 453.39C932.828 453.059 933.027 452.668 933.131 452.249C933.236 451.829 933.244 451.392 933.154 450.969C933.064 450.546 932.88 450.149 932.614 449.807C932.348 449.466 932.008 449.19 931.62 449C923.146 457.963 915.653 467.805 909.27 478.36"
            fill="url(#paint0_linear_62_2176)"
          />
          <path
            id="Portal_2"
            d="M98.56 43.7401C94.5 37.2201 87.93 34.7401 82.74 29.8701C77.55 25.0001 73.74 14.6601 77.94 8.31005C75.05 -3.46995 61.22 -1.76995 55.03 7.44005C48.84 16.6501 46.83 29.6701 41.37 39.6701C38.51 39.4601 38.24 33.6701 39.76 30.4101C41.28 27.1501 43.76 24.1001 43.4 20.3001C42.67 12.5401 32.69 16.4001 31.46 24.0401C30.23 31.6801 33.04 39.7301 31.73 47.3501C29.62 59.7101 17.62 66.1901 16.62 78.8001C16.26 83.2801 17.42 87.6901 18.36 92.0101C22.4942 111.13 22.9388 130.863 19.67 150.15L14.62 142.83C5.12002 148.52 7.49002 167.83 13.49 179.25C19.49 190.67 28.01 202.45 26 216.13C25.895 217.539 25.396 218.891 24.56 220.03C20.56 224.35 17.82 212.33 13.2 209.39C10.57 207.72 7.38002 209.49 5.27002 212.16C-4.45998 224.44 2.86002 246.21 11.27 260.09C19.68 273.97 29.62 292.2 23.18 307.91C19.66 309.91 16.62 303.83 15.92 298.79C15.22 293.75 14.25 287.31 10.49 286.36C4.79002 284.93 3.67002 296.87 5.29002 304.36L19.34 369C20.23 373.09 21.09 377.65 19.66 381.46C18.23 385.27 13.4 386.56 12.07 382.69C2.90002 406.07 28.46 431.39 24.67 457.31L10.9 446.38C5.90002 454.38 9.29002 466.85 14.61 474.44C19.93 482.03 27.01 487.59 30.84 496.64L29.3 494.77C27.69 501.65 22.22 505.3 18.77 510.83C15.32 516.36 15.77 527.67 21.16 527.83C23.7 527.89 25.76 525.2 28.16 523.99C40.33 517.81 47.08 550.08 60.05 548.67C67.59 547.84 71.41 535.77 71.45 525.67C71.49 515.57 69.52 504.91 72.45 495.55L80.15 507.55C84.38 504.6 87.03 498.01 86.55 491.65C86.23 487.5 84.72 483.65 84.01 479.65C81.19 463.52 90.89 448.96 98.01 435.4C105.13 421.84 108.93 399.84 98.35 391.24C96.4836 393.356 94.9433 395.739 93.78 398.31C92.12 377.13 79 352.07 89.49 335.79C88.84 339.62 91.08 343.86 93.99 344.33C100.48 340.87 101.42 328.84 99.41 319.88C97.4 310.92 93.49 302.29 94.1 292.97C94.96 279.88 104.1 271.13 110.24 260.97C116.38 250.81 118.24 231.92 109.05 227.42C106.05 230.62 108.16 237.36 106.56 242.03C104.56 247.76 97.62 247.03 94.85 241.96C92.08 236.89 92.55 229.79 93.97 223.77C95.39 217.75 97.63 212 98.09 205.77C98.92 194.19 93.61 183.66 90.56 172.77C87.51 161.88 87.97 146.68 95.93 142.04C91.13 140.51 89.93 131.7 91.58 125.45C93.23 119.2 96.5 113.69 97.1 107.12C98.1 96.1201 91.43 86.9301 85.79 78.8201C80.15 70.7101 74.75 58.9201 78.62 49.1001L94.97 63.6701C101.3 63.2801 102.62 50.2501 98.56 43.7401ZM39.33 95.7401C39.047 96.069 38.8428 96.4582 38.7331 96.8781C38.6233 97.2979 38.6109 97.7373 38.6967 98.1627C38.7826 98.588 38.9644 98.9882 39.2284 99.3326C39.4924 99.677 39.8316 99.9566 40.22 100.15C48.7181 91.1842 56.2279 81.331 62.62 70.7601"
            fill="url(#paint1_linear_62_2176)"
          />
          <g id="Rails">
            <path
              id="Vector"
              d="M54.76 426.48H909.76"
              stroke="#664966"
              stroke-width="5"
              stroke-miterlimit="10"
            />
            <path
              id="Vector_2"
              d="M70.26 442.48H922.76"
              stroke="#664966"
              stroke-width="5"
              stroke-miterlimit="10"
            />
            <path
              id="Vector_3"
              d="M156.45 425.92L134.45 442.92"
              stroke="#664966"
              stroke-width="3"
              stroke-miterlimit="10"
            />
            <path
              id="Vector_4"
              d="M239.45 425.92L234.45 442.92"
              stroke="#664966"
              stroke-width="3"
              stroke-miterlimit="10"
            />
            <path
              id="Vector_5"
              d="M338.45 426.92L335.45 442.92"
              stroke="#664966"
              stroke-width="3"
              stroke-miterlimit="10"
            />
            <path
              id="Vector_6"
              d="M448.45 426.92V442.92"
              stroke="#664966"
              stroke-width="3"
              stroke-miterlimit="10"
            />
            <path
              id="Vector_7"
              d="M548.45 426.92L553.45 442.92"
              stroke="#664966"
              stroke-width="3"
              stroke-miterlimit="10"
            />
            <path
              id="Vector_8"
              d="M654.45 426.92L665.45 442.92"
              stroke="#664966"
              stroke-width="3"
              stroke-miterlimit="10"
            />
            <path
              id="Vector_9"
              d="M754.45 427.92L770.45 442.92"
              stroke="#664966"
              stroke-width="3"
              stroke-miterlimit="10"
            />
            <path
              id="Vector_10"
              d="M836.45 426.92L874.45 442.92"
              stroke="#664966"
              stroke-width="3"
              stroke-miterlimit="10"
            />
          </g>
          <path
            id="Portal_3"
            d="M68.04 431.69C66.04 433.98 62.96 433.44 60.68 431.86C57.59 429.7 56.93 426.11 57.74 422.57C59.58 414.57 66.74 409.06 68.84 401.15C73.27 384.72 53.06 378.57 47.16 366.4C45.44 362.85 45.38 359.06 47.68 355.76C49.68 352.92 53.27 350.76 56.57 352.76C56.7996 352.893 57.06 352.962 57.325 352.962C57.5901 352.962 57.8505 352.893 58.08 352.76C66.53 347.58 67.35 336.7 65.85 327.83C64.85 321.73 62.55 315.91 61.52 309.83C60.8643 306.441 60.8643 302.959 61.52 299.57C62.2987 296.656 63.5232 293.88 65.15 291.34C67.76 286.78 69.58 282.34 68.81 277.01C68.11 272.23 65.91 267.82 63.95 263.46C62.08 259.31 59.87 254.59 60.54 249.91C61.35 244.25 66.54 241.31 70.41 237.82C74.583 234.028 77.1136 228.759 77.4646 223.131C77.8157 217.504 75.9594 211.961 72.29 207.68C72.0556 207.448 71.7512 207.3 71.424 207.258C71.0968 207.217 70.765 207.284 70.48 207.45L60.31 214.18C49.45 200.03 56.78 180.18 61.16 164.97C63.87 155.59 66.16 145.66 64.3 135.88C62.5 126.32 55.99 118.88 52.86 109.88C50.62 103.31 50.91 93.15 57.92 89.69L65.3 101.39C65.4547 101.637 65.6769 101.833 65.9403 101.957C66.2036 102.081 66.497 102.127 66.7855 102.089C67.0741 102.051 67.3457 101.931 67.5681 101.744C67.7905 101.556 67.9543 101.308 68.04 101.03C69.7243 96.8943 70.4919 92.4426 70.29 87.9817C70.088 83.5207 68.9212 79.1566 66.87 75.19C65.99 73.47 63.4 74.98 64.28 76.7C67.5083 83.0392 68.195 90.3716 66.2 97.2C64.0734 93.8133 61.9367 90.4134 59.79 87C59.6199 86.7187 59.3636 86.4997 59.0592 86.3754C58.7548 86.2511 58.4185 86.2282 58.1 86.31C51.1 88.9 48.3 96.36 48.58 103.37C48.95 112.81 55.16 120.37 58.88 128.73C67.88 148.92 54.19 169.53 52.07 189.73C51.07 199.46 52.45 209.54 58.92 217.23C59.1527 217.465 59.4573 217.615 59.7854 217.657C60.1134 217.699 60.446 217.629 60.73 217.46L70.9 210.73C73.6412 214.434 74.9098 219.024 74.46 223.61C73.98 229.05 71.2 233.27 67.08 236.7C63.36 239.79 59.36 242.7 57.95 247.61C56.79 251.61 57.71 255.91 59.15 259.76C62.45 268.59 68.96 277.43 64.15 286.94C61.61 291.94 58.67 296.2 58.15 301.94C57.62 307.94 59.23 313.94 60.79 319.64C63.3 328.87 66.79 343.16 57.27 349.71C51.27 346.83 44.69 352.51 43.27 358.41C41.19 366.75 48.45 373.95 54.12 378.89C60.62 384.61 68.88 391.6 65.62 401.31C62.68 410.11 53.33 416.76 54.47 426.85C54.6818 428.702 55.3799 430.465 56.4934 431.959C57.6069 433.454 59.0962 434.627 60.81 435.36C62.0865 436.003 63.5096 436.299 64.9366 436.218C66.3636 436.137 67.7442 435.683 68.94 434.9C71.54 438.51 70.94 443.53 69.24 447.5C67.04 452.65 62.85 456.68 59.86 461.35C57.0549 465.636 55.585 470.657 55.6366 475.779C55.6882 480.901 57.259 485.892 60.15 490.12C61.24 491.69 63.84 490.19 62.74 488.6C59.5745 484.079 58.1341 478.572 58.68 473.08C59.27 467.13 62.6 462.4 66.12 457.78C69.31 453.59 72.48 449.3 73.4 443.99C74.18 439.54 73.4 434.99 70.13 431.69C69.8489 431.421 69.4745 431.27 69.085 431.27C68.6956 431.27 68.3212 431.421 68.04 431.69Z"
            fill="#BB6CAD"
          />
          <path
            id="Portal_4"
            d="M930.62 194.14C928.98 189.69 925.22 185.96 920.18 186.47C919.855 186.484 919.543 186.597 919.283 186.794C919.024 186.99 918.831 187.261 918.73 187.57C917.73 190.12 916.73 192.66 915.73 195.21C910.39 194.85 907.41 188.81 907.36 183.88C907.29 176.78 912.29 170.48 915.17 164.32C917.819 158.613 919.176 152.392 919.145 146.1C919.114 139.808 917.695 133.601 914.99 127.92C918.9 127.24 921.9 124.07 923.4 120.33C925.64 114.74 924.33 109.08 921.16 104.14C917.45 98.3901 911.88 94.1401 908.16 88.3801C905.16 83.7301 901.69 74.5101 907.81 70.6901C911.17 68.6001 918.71 68.8301 918.57 74.1401C918.52 76.0701 921.52 76.0701 921.57 74.1401C921.7 69.4601 917.66 66.7901 913.36 66.4801C908.53 66.1201 903.93 68.5701 902.27 73.2201C899.86 79.9901 903.37 87.3101 907.5 92.5901C912.02 98.3701 918.5 103.18 920.9 110.36C922.84 116.09 919.98 125.69 912.59 125.02C912.328 125.025 912.071 125.098 911.845 125.231C911.619 125.365 911.431 125.554 911.3 125.782C911.169 126.01 911.099 126.267 911.098 126.53C911.096 126.792 911.162 127.051 911.29 127.28C914.947 133.954 916.613 141.538 916.09 149.13C915.846 153.023 915.014 156.857 913.62 160.5C912.099 163.98 910.397 167.378 908.52 170.68C905.52 176.43 903.1 182.81 905.35 189.25C907.08 194.25 911.18 198.58 916.79 198.25C917.114 198.238 917.427 198.126 917.685 197.929C917.943 197.732 918.133 197.46 918.23 197.15L921.29 189.49C925 189.66 927.36 192.91 928.29 196.42C929.5 201.17 927.78 205.42 924.67 209.07C917.93 216.93 907.5 221.32 904.18 231.87C903.437 233.989 903.23 236.259 903.579 238.477C903.928 240.695 904.822 242.792 906.18 244.58C909.34 248.58 914.18 250.87 917.05 255.2C921.79 262.32 922.98 274.74 914.58 279.85C907.94 283.85 895.76 281.11 894.89 272.27C894.8 271.27 893.64 270.21 892.64 270.97C884.95 276.82 882.58 287.76 886.5 296.51C888.71 301.46 892.94 304.73 897.76 307C903.06 309.49 909.56 310.86 913.92 315C917.15 318.05 920.35 323.93 917.92 328.32C916.39 331.09 913.16 331.65 910.38 332.47C907.912 333.067 905.665 334.354 903.9 336.18C900.75 339.71 900.12 344.72 900.82 349.24C901.68 354.84 904.82 359.39 908.41 363.64C912.33 368.32 917.2 372.87 919.08 378.85C920.52 383.46 920.61 389.8 916.52 393.17C912.2 396.72 905.65 395.17 902.06 400.17C899.26 404.03 899.91 409.28 901.63 413.44C903.73 418.54 907.68 421.98 911.63 425.62C915.32 428.99 920.98 433.98 920.2 439.62C919.72 443.08 915.66 448.71 911.54 447.3C910.54 446.97 910.16 446 909.29 445.65C908.327 445.45 907.324 445.587 906.45 446.04C904.809 446.698 903.456 447.917 902.63 449.48C900.63 453.12 901.16 457.86 902.55 461.59C904.34 466.42 908.23 469.66 911.61 473.37C915.49 477.63 918.69 482.65 916.05 488.44C914.05 492.86 910.31 496.35 908.77 501C908.07 503.045 908.07 505.265 908.77 507.31C909.39 509.13 912.29 508.31 911.66 506.51C909.75 500.87 915.58 495.72 918.04 491.18C921.12 485.53 920.42 479.86 916.64 474.73C913.01 469.81 907.17 466.07 905.22 460.1C903.95 456.23 903.61 449.99 908.22 448.66C912.88 453.07 919.71 448.47 922.06 443.57C925.74 435.9 919.6 428.9 914.24 423.97C911.03 421.02 907.5 418.25 905.35 414.39C903.56 411.18 902.22 406.82 903.73 403.25C905.64 398.74 911.07 398.97 914.99 397.47C916.611 396.858 918.078 395.898 919.288 394.658C920.497 393.417 921.42 391.926 921.99 390.29C924.81 382.57 921.26 374.69 916.5 368.66C910.98 361.66 903.26 355.25 903.5 345.57C903.6 341.7 905.22 337.87 908.91 336.2C912.76 334.45 917.25 334.46 919.91 330.71C924.14 324.8 920.07 316.33 915.15 312.22C907.67 305.97 895.58 306.08 890.15 297.22C886.01 290.49 886.89 280.82 892.44 275.14C894.72 281.95 902.52 285.48 909.62 284.65C919.73 283.47 924.78 273.65 923.48 264.15C922.781 259.029 920.502 254.254 916.96 250.49C912.96 246.31 906.46 243.56 906.35 236.95C906.25 230.73 910.79 225.3 915.24 221.47C919.69 217.64 924.87 214.13 928.39 209.18C929.991 207.06 931.034 204.572 931.423 201.945C931.813 199.317 931.537 196.633 930.62 194.14Z"
            fill="#BB6CAD"
          />
          <path
            id="Portal_5"
            d="M95.26 379C83.62 442 68.67 489.83 63.26 489C61.74 488.76 59.95 484.5 59.26 482C57.76 476.55 59.37 471.63 60.26 469C61.26 466.18 62.9 463.45 66.26 458C69.9 452.09 70.18 452.39 71.26 450C73.53 445 75.2 437.21 72.26 435C70.9 434 69.83 435.08 65.26 434C63.03 433.47 61.6 433.13 60.26 432C57.6 429.75 57.34 426.14 57.26 425C57.07 422.35 57.7 419.73 60.26 415C65.13 406 68 406 69.26 401C70.79 395 67.98 389.41 67.26 388C65.26 384.07 63.7 384.16 54.26 375C48.92 369.82 47.03 367.46 46.26 364C45.97 362.67 45.16 359 47.26 356C48.1967 354.559 49.6139 353.496 51.26 353C53.32 352.47 54.26 353.48 56.26 353C57.8946 352.482 59.3049 351.424 60.26 350C66.35 342.42 66.26 332 66.26 332C66.26 328.92 65.84 329.84 62.26 313C60.94 306.77 60.4 303.83 61.26 300C62.03 296.56 63.15 295.86 65.26 291C67.57 285.65 69.35 281.56 69.26 277C69.15 271.37 66.35 271.45 62.26 259C60.46 253.52 59.92 250.2 61.26 247C61.88 245.51 62.66 244.64 65.26 242C74.17 232.91 74.18 233.74 75.26 232C78.69 226.46 78.26 218.64 75.26 213C74.0155 210.683 72.3146 208.642 70.26 207C64.51 214.56 61.26 214.24 60.26 214C55.12 212.73 53.85 200 54.26 192C54.48 187.71 56.41 181.08 60.26 168C63.19 158.05 64.76 153.5 65.26 146C65.6867 141.642 65.3483 137.242 64.26 133C63.79 131.28 63.26 129.92 59.26 122C53.54 110.69 52.88 110 52.26 107C51.72 104.31 50.37 97.65 54.26 93C55.3493 91.7104 56.7169 90.6846 58.26 90C60.83 94.3801 65.63 101.88 68.26 101C70.52 100.24 70.33 93.58 70.26 91C69.99 81.55 66.51 75.4101 67.26 75.0001C68.26 74.4201 75.82 85.7801 78.26 90C131.69 182.23 95.26 379 95.26 379Z"
            fill="url(#paint2_linear_62_2176)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_62_2176"
            x1="778.379"
            y1="112.834"
            x2="1051.95"
            y2="432.821"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#76217E" />
            <stop offset="0.55" stop-color="#954D9A" />
            <stop offset="1" stop-color="#AB6CAD" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_62_2176"
            x1="193.522"
            y1="436.296"
            x2="-80.0528"
            y2="116.308"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AB6CAD" />
            <stop offset="0.45" stop-color="#954D9A" />
            <stop offset="1" stop-color="#76217E" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_62_2176"
            x1="45.86"
            y1="281.97"
            x2="107.39"
            y2="281.97"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.01" stop-color="#BB6CAD" />
            <stop offset="0.12" stop-color="#BB6CAD" stop-opacity="0.83" />
            <stop offset="0.37" stop-color="#BB6CAD" stop-opacity="0.41" />
            <stop offset="0.6" stop-color="#BB6CAD" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
      <svg
        id="Mayura"
        src="/assets/loading-mayura.svg"
        alt="loading-mayura"
        width="193"
        height="199"
        viewBox="0 0 193 199"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.63 88.13C38.89 91.75 52.12 95.39 61.36 98.13C69.65 100.63 78.68 103.32 87.73 99.26C90.9503 97.7903 93.8309 95.669 96.19 93.03C95.4 86.03 92.88 82.03 90.63 79.56C79.42 67.49 51.34 70.11 21.63 88.13Z"
          fill="#8E8395"
        />
        <path
          d="M21.63 88.13C38.89 91.75 52.12 95.39 61.36 98.13C69.65 100.63 78.68 103.32 87.73 99.26C90.9503 97.7903 93.8309 95.669 96.19 93.03C95.4 86.03 92.88 82.03 90.63 79.56C79.42 67.49 51.34 70.11 21.63 88.13Z"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
        />
        <path
          d="M30.44 83.22C43.36 80.14 63.86 77.56 85.56 85.54C88.9851 86.8002 92.3253 88.2799 95.56 89.97C95.5056 86.4477 94.3942 83.023 92.37 80.14C83.24 67.67 57 72.57 44.08 77C39.3469 78.6372 34.7797 80.7199 30.44 83.22V83.22Z"
          fill="#C0B6C7"
        />
        <path
          d="M60.1539 81.614C60.43 81.5582 60.605 81.2716 60.5449 80.9739C60.4848 80.6761 60.2122 80.48 59.9361 80.5357C59.66 80.5915 59.4849 80.8781 59.5451 81.1758C59.6052 81.4736 59.8778 81.6697 60.1539 81.614Z"
          stroke="#E7DFEC"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M53.4207 81.0222C53.6589 80.9741 53.797 80.663 53.7292 80.3273C53.6614 79.9917 53.4134 79.7586 53.1752 79.8067C52.937 79.8549 52.7989 80.166 52.8667 80.5016C52.9345 80.8372 53.1825 81.0703 53.4207 81.0222Z"
          stroke="#E7DFEC"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M30.44 83.22C43.36 80.14 63.86 77.56 85.56 85.54C88.9851 86.8002 92.3253 88.2799 95.56 89.97C95.5056 86.4477 94.3942 83.023 92.37 80.14C83.24 67.67 57 72.57 44.08 77C39.3469 78.6372 34.7797 80.7199 30.44 83.22V83.22Z"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
        />
        <path
          d="M100.56 169.36C88.4 172.91 76.44 163.52 69.56 158.08C54 145.86 32 118 42.46 95.51C49.46 80.41 67.46 75.51 73.03 73.95C78.6 72.39 96.37 67.54 110.15 76.82C130.78 90.72 126.05 125.07 121.15 140.82C118.45 149.59 113.49 165.58 100.56 169.36Z"
          fill="#C0B6C7"
        />
        <path
          d="M91.22 68.57L98.22 92.22"
          stroke="#E7DFEC"
          stroke-width="3"
          stroke-miterlimit="10"
        />
        <path
          d="M99.65 102.14C102.445 102.14 104.71 99.8746 104.71 97.08C104.71 94.2855 102.445 92.02 99.65 92.02C96.8554 92.02 94.59 94.2855 94.59 97.08C94.59 99.8746 96.8554 102.14 99.65 102.14Z"
          stroke="#E7DFEC"
          stroke-width="3"
          stroke-miterlimit="10"
        />
        <path
          d="M42.18 121.32C45.1484 122.286 48.2131 122.926 51.32 123.23C54.3839 123.536 57.4719 123.509 60.53 123.15"
          stroke="#E7DFEC"
          stroke-width="3"
          stroke-miterlimit="10"
        />
        <path
          d="M71.64 160.76L59.13 122.9"
          stroke="#E7DFEC"
          stroke-width="3"
          stroke-miterlimit="10"
        />
        <path
          d="M57.09 130.74C57.3937 130.74 57.64 130.494 57.64 130.19C57.64 129.886 57.3937 129.64 57.09 129.64C56.7862 129.64 56.54 129.886 56.54 130.19C56.54 130.494 56.7862 130.74 57.09 130.74Z"
          stroke="#E7DFEC"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M60.36 140.34C60.6638 140.34 60.91 140.094 60.91 139.79C60.91 139.486 60.6638 139.24 60.36 139.24C60.0562 139.24 59.81 139.486 59.81 139.79C59.81 140.094 60.0562 140.34 60.36 140.34Z"
          stroke="#E7DFEC"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M100.56 169.36C88.4 172.91 76.44 163.52 69.56 158.08C54 145.86 32 118 42.46 95.51C49.46 80.41 67.46 75.51 73.03 73.95C78.6 72.39 96.37 67.54 110.15 76.82C130.78 90.72 126.05 125.07 121.15 140.82C118.45 149.59 113.49 165.58 100.56 169.36Z"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
        />
        <path
          d="M33.81 49.86C27.47 38.99 32.3 23.86 41.62 14.86C57.01 -0.0699596 86.62 -0.39996 101.9 14.86C111.51 24.48 115.35 40.23 108.44 51.03C95.31 71.51 45.8 70.44 33.81 49.86Z"
          fill="#C0B6C7"
        />
        <path
          d="M86.9359 46.8663L86.94 46.87C92.0465 51.4962 100.194 53.2747 108.5 53.3793C113.7 40.0829 110.328 29.9195 107.992 26.4999C107.592 25.9373 107.152 25.3495 106.644 24.7626C105.994 24.0121 105.232 23.2631 104.3 22.57C101.031 20.3117 97.0599 19.3037 93.11 19.73C86.48 20.21 80.21 26.8 79.94 33.94C79.7401 40.3558 84.8334 44.964 86.9359 46.8663Z"
          fill="#746F77"
        />
        <path
          d="M96.11 51.3C105.018 51.3 112.24 44.0783 112.24 35.17C112.24 26.2616 105.018 19.04 96.11 19.04C87.2016 19.04 79.98 26.2616 79.98 35.17C79.98 44.0783 87.2016 51.3 96.11 51.3Z"
          fill="url(#paint0_radial_63_2177)"
        />
        <path
          d="M96.43 43.71C100.97 43.71 104.65 40.0297 104.65 35.49C104.65 30.9502 100.97 27.27 96.43 27.27C91.8902 27.27 88.21 30.9502 88.21 35.49C88.21 40.0297 91.8902 43.71 96.43 43.71Z"
          fill="#FFD8FF"
        />
        <path
          d="M45.2 8.92003C45.2 9.84882 45.4225 10.7256 45.8172 11.5001M45.8172 11.5001C46.7578 13.3459 48.6763 14.61 50.89 14.61C54.0325 14.61 56.58 12.0625 56.58 8.92003C56.58 7.97871 56.3514 7.09078 55.9468 6.30872L45.8172 11.5001Z"
          stroke="#E7DFEC"
          stroke-width="3"
          stroke-miterlimit="10"
        />
        <path
          d="M33.7464 49.7967C27.4064 38.9267 32.2364 23.7967 41.5564 14.7967C56.9464 -0.133314 86.5564 -0.463314 101.836 14.7967C111.446 24.4167 115.286 40.1667 108.376 50.9667C95.2464 71.4467 45.7364 70.3767 33.7464 49.7967Z"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
        />
        <path
          d="M35.13 196.25C42.7239 196.25 48.88 190.206 48.88 182.75C48.88 175.294 42.7239 169.25 35.13 169.25C27.5361 169.25 21.38 175.294 21.38 182.75C21.38 190.206 27.5361 196.25 35.13 196.25Z"
          fill="#706A6A"
        />
        <path
          d="M35.13 171.75C37.2943 171.799 39.3959 172.486 41.1717 173.724C42.9474 174.962 44.3183 176.697 45.1127 178.711C45.9071 180.725 46.0895 182.928 45.6373 185.045C45.185 187.162 44.1182 189.099 42.5703 190.612C41.0224 192.126 39.0624 193.149 36.9357 193.553C34.809 193.958 32.6102 193.726 30.6148 192.887C28.6193 192.047 26.9159 190.638 25.7179 188.834C24.5199 187.031 23.8806 184.915 23.88 182.75C23.9169 179.801 25.122 176.986 27.231 174.924C29.3399 172.862 32.1806 171.721 35.13 171.75V171.75ZM35.13 166.75C31.9766 166.799 28.9081 167.779 26.31 169.567C23.7119 171.355 21.7001 173.871 20.5274 176.798C19.3546 179.726 19.0732 182.935 19.7185 186.022C20.3638 189.109 21.9071 191.936 24.1543 194.149C26.4016 196.362 29.2527 197.861 32.3494 198.458C35.4461 199.056 38.6502 198.725 41.5593 197.507C44.4684 196.289 46.9526 194.238 48.6999 191.613C50.4472 188.987 51.3796 185.904 51.38 182.75C51.3643 180.632 50.9315 178.538 50.1062 176.588C49.2809 174.637 48.0794 172.869 46.5703 171.383C45.0612 169.897 43.2741 168.723 41.3111 167.928C39.3482 167.133 37.2478 166.733 35.13 166.75V166.75Z"
          fill="#383535"
        />
        <path
          d="M131.38 196.25C138.974 196.25 145.13 190.206 145.13 182.75C145.13 175.294 138.974 169.25 131.38 169.25C123.786 169.25 117.63 175.294 117.63 182.75C117.63 190.206 123.786 196.25 131.38 196.25Z"
          fill="#706A6A"
        />
        <path
          d="M131.38 171.75C133.544 171.799 135.646 172.486 137.422 173.724C139.197 174.962 140.568 176.697 141.363 178.711C142.157 180.725 142.34 182.928 141.887 185.045C141.435 187.162 140.368 189.099 138.82 190.612C137.272 192.126 135.312 193.149 133.186 193.553C131.059 193.958 128.86 193.726 126.865 192.887C124.869 192.047 123.166 190.638 121.968 188.834C120.77 187.031 120.131 184.915 120.13 182.75C120.167 179.801 121.372 176.986 123.481 174.924C125.59 172.862 128.431 171.721 131.38 171.75V171.75ZM131.38 166.75C128.227 166.799 125.158 167.779 122.56 169.567C119.962 171.355 117.95 173.871 116.777 176.798C115.605 179.726 115.323 182.935 115.969 186.022C116.614 189.109 118.157 191.936 120.404 194.149C122.652 196.362 125.503 197.861 128.599 198.458C131.696 199.056 134.9 198.725 137.809 197.507C140.718 196.289 143.203 194.238 144.95 191.613C146.697 188.987 147.63 185.904 147.63 182.75C147.614 180.632 147.181 178.538 146.356 176.588C145.531 174.637 144.329 172.869 142.82 171.383C141.311 169.897 139.524 168.723 137.561 167.928C135.598 167.133 133.498 166.733 131.38 166.75V166.75Z"
          fill="#383535"
        />
        <path
          d="M168.38 196.25C175.974 196.25 182.13 190.206 182.13 182.75C182.13 175.294 175.974 169.25 168.38 169.25C160.786 169.25 154.63 175.294 154.63 182.75C154.63 190.206 160.786 196.25 168.38 196.25Z"
          fill="#706A6A"
        />
        <path
          d="M168.38 171.75C170.544 171.799 172.646 172.486 174.422 173.724C176.197 174.962 177.568 176.697 178.363 178.711C179.157 180.725 179.34 182.928 178.887 185.045C178.435 187.162 177.368 189.099 175.82 190.612C174.272 192.126 172.312 193.149 170.186 193.553C168.059 193.958 165.86 193.726 163.865 192.887C161.869 192.047 160.166 190.638 158.968 188.834C157.77 187.031 157.131 184.915 157.13 182.75C157.167 179.801 158.372 176.986 160.481 174.924C162.59 172.862 165.431 171.721 168.38 171.75V171.75ZM168.38 166.75C165.227 166.799 162.158 167.779 159.56 169.567C156.962 171.355 154.95 173.871 153.777 176.798C152.605 179.726 152.323 182.935 152.969 186.022C153.614 189.109 155.157 191.936 157.404 194.149C159.652 196.362 162.503 197.861 165.599 198.458C168.696 199.056 171.9 198.725 174.809 197.507C177.718 196.289 180.203 194.238 181.95 191.613C183.697 188.987 184.63 185.904 184.63 182.75C184.614 180.632 184.181 178.538 183.356 176.588C182.531 174.637 181.329 172.869 179.82 171.383C178.311 169.897 176.524 168.723 174.561 167.928C172.598 167.133 170.498 166.733 168.38 166.75V166.75Z"
          fill="#383535"
        />
        <path
          d="M12.88 180.67V120.67H27L48.29 160.21H141.9L141.63 120.93C153.984 122.18 165.458 127.893 173.9 137C179.797 143.619 184.131 151.48 186.58 160C188.538 166.693 189.39 173.662 189.1 180.63L12.88 180.67Z"
          fill="#8C334B"
        />
        <path
          d="M24.91 124.17L37.31 147.17L44.21 160L46.21 163.68H145.44L145.39 156.63L145.25 136.86L145.17 124.96C155.217 126.773 164.399 131.815 171.32 139.32C176.865 145.561 180.932 152.971 183.22 161C184.758 166.248 185.575 171.681 185.65 177.15H16.38V124.15H24.91V124.17ZM138.1 117.15C138.193 130.33 138.287 143.51 138.38 156.69H50.38C43.28 143.51 36.1833 130.33 29.09 117.15H9.38V184.15H192.38C193.136 175.698 192.308 167.179 189.94 159.03C187.339 149.985 182.739 141.639 176.48 134.61C161.84 118.61 143.06 117.31 138.1 117.15Z"
          fill="#590031"
        />
        <path
          d="M4.25 110.66C30.06 89.52 56.61 83.52 68.45 92.84C70.87 94.74 74.33 98.58 75.62 106.72C75.4 115.04 72.44 119.25 70.28 121.4C59.73 131.94 32.62 128.86 4.25 110.66Z"
          fill="#C0B6C7"
        />
        <path
          d="M84.41 116.85C81.41 112.85 73.1 102.6 58.64 98.85C54.0449 97.676 49.2901 97.2539 44.56 97.6"
          stroke="#E7DFEC"
          stroke-width="3"
          stroke-miterlimit="10"
        />
        <path
          d="M40.2 111.09C39.8882 105.969 41.6218 100.934 45.02 97.09"
          stroke="#E7DFEC"
          stroke-width="3"
          stroke-miterlimit="10"
        />
        <path
          d="M6.60001 108.9L40.82 109.79"
          stroke="#E7DFEC"
          stroke-width="3"
          stroke-miterlimit="10"
        />
        <path
          d="M64.03 105.52C64.3338 105.52 64.58 105.274 64.58 104.97C64.58 104.666 64.3338 104.42 64.03 104.42C63.7263 104.42 63.48 104.666 63.48 104.97C63.48 105.274 63.7263 105.52 64.03 105.52Z"
          stroke="#E7DFEC"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M51.8 102.5C52.1038 102.5 52.35 102.254 52.35 101.95C52.35 101.646 52.1038 101.4 51.8 101.4C51.4962 101.4 51.25 101.646 51.25 101.95C51.25 102.254 51.4962 102.5 51.8 102.5Z"
          stroke="#E7DFEC"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M4.25 110.66C30.06 89.52 56.61 83.52 68.45 92.84C70.87 94.74 74.33 98.58 75.62 106.72C75.4 115.04 72.44 119.25 70.28 121.4C59.73 131.94 32.62 128.86 4.25 110.66Z"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
        />
        <defs>
          <radialGradient
            id="paint0_radial_63_2177"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(3180.49 1121.36) scale(520.354)"
          >
            <stop stop-color="#FFD8FF" />
            <stop offset="0.18" stop-color="#FFD8FF" stop-opacity="0.73" />
            <stop offset="0.37" stop-color="#FFD8FF" stop-opacity="0.48" />
            <stop offset="0.54" stop-color="#FFD8FF" stop-opacity="0.27" />
            <stop offset="0.69" stop-color="#FFD8FF" stop-opacity="0.12" />
            <stop offset="0.81" stop-color="#FFD8FF" stop-opacity="0.03" />
            <stop offset="0.89" stop-color="#FFD8FF" stop-opacity="0" />
          </radialGradient>
        </defs>
      </svg>
      <span>ЗАРЕЖДАНЕ...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainLoading",
};
</script>

<style scoped>
.Loading {
  position: relative;
  top: 50%;
  transform: translateY(calc(50vh - 50%));
  margin-left: 38%;
  margin-right: 42%;
  z-index: 1001;
  width: 20%;
  height: max-content;
}

#Mayura {
  position: absolute;
  bottom: 17%;
  left: 1%;
  animation: tracks 0.8s cubic-bezier(0, 0, 1, 1) 0s infinite;
}

@keyframes tracks {
  0% {
    z-index: -1;
  }

  45% {
    z-index: 1;
  }

  95% {
    z-index: -1;
  }

  100% {
    z-index: -1;
    transform: translateX(390%);
  }
}

#LoadingBackground {
  width: 100%;
  height: auto;
}

#Mayura {
  height: 35%;
  width: auto;
}

.Loading span {
  color: white;
  display: block;
  width: 100%;
  position: absolute;
  font-size: 3vw;
}
</style>
